import React from "react";
import { Container, Link } from "@material-ui/core";
import SubmitServiceCallForm from "./SubmitServiceCallForm";
import ImgHeader from "../ImgHeader";
import BlockQuote from "../BlockQuote";
import { H1, H2, H3 } from "../Headers";
import styled from "styled-components";

const Wrapper = styled(Container)`
  padding: 2em;
  margin: 0;
  max-width: 800px;
`;

export default function SubmitServiceCall() {
  return (
    <>
      <ImgHeader url="/static/img/Card-SubmitATicket.png" shadowOpacity={0.3}>
        <H1>Ask A Question</H1>
      </ImgHeader>
      <Wrapper>
        <Container>
          <H2>Talk to a real person</H2>
          <BlockQuote>
            Need help with an existing integration with Skyward? Have a question about one of Skyward's APIs? Have any other general question? We are here to
            help. Send us a message below!
          </BlockQuote>
          <SubmitServiceCallForm isServiceRequest={false} />
        </Container>
      </Wrapper>
    </>
  );
}
